const FAQS = [
  {
    q: '妖精视频是否需要注册才能观看？',
    a: '完全不需要注册。妖精视频是一个内容聚合导航平台，所有视频直接链接至香蕉视频、蜜桃视频、西瓜视频、樱花视频等合作平台，您可以直接点击观看，无需任何账号注册流程。',
  },
  {
    q: '视频画质如何？播放会卡顿缓冲吗？',
    a: '所有聚合内容均提供高清画质选项，各合作平台均采用先进的CDN加速与流媒体传输技术，确保播放流畅不缓冲。如遇网络波动，系统会自动调整码率以保证观看连续性。',
  },
  {
    q: '平台覆盖哪些类型的内容？',
    a: '妖精视频覆盖电影、电视剧、综艺、动漫、纪录片、音乐MV、游戏实况、短剧等多达九大内容板块，每日同步更新香蕉视频、蜜桃视频、西瓜视频、樱花视频、糖豆视频、樱桃视频、蘑菇视频七个平台的最新内容。',
  },
  {
    q: '是否支持手机端观看？',
    a: '支持。妖精视频采用响应式设计，完美适配手机、平板和电脑等多种设备。各合作平台也均有独立移动端应用，您可以直接通过本平台入口跳转观看，享受跨设备无缝观影体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          关于妖精视频的常见问题解答
        </p>
        <div className="max-w-2xl mx-auto space-y-3">
          {FAQS.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-100 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-foreground-500 text-sm"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}